import React from 'react';

import { IIconProps, TIconType } from '../interface';

const MiddlewareSMOIcon: TIconType = (props?: IIconProps) => {
	return (
		!props?.isActive ? (
			<svg
				fill='none'
				height='24'
				viewBox='0 0 20 24'
				width='20'
			>
				<path
					d='M2 1H18C18.2652 1 18.5196 1.10536 18.7071 1.29289C18.8946 1.48043 19 1.73478 19 2V6C19 6.26522 18.8946 6.51957 18.7071 6.70711C18.5196 6.89464 18.2652 7 18 7H2C1.73478 7 1.48043 6.89464 1.29289 6.70711C1.10536 6.51957 1 6.26522 1 6V2C1 1.73478 1.10536 1.48043 1.29289 1.29289C1.48043 1.10536 1.73478 1 2 1M2 9H18C18.2652 9 18.5196 9.10536 18.7071 9.29289C18.8946 9.48043 19 9.73478 19 10V14C19 14.2652 18.8946 14.5196 18.7071 14.7071C18.5196 14.8946 18.2652 15 18 15H2C1.73478 15 1.48043 14.8946 1.29289 14.7071C1.10536 14.5196 1 14.2652 1 14V10C1 9.73478 1.10536 9.48043 1.29289 9.29289C1.48043 9.10536 1.73478 9 2 9M2 17H18C18.2652 17 18.5196 17.1054 18.7071 17.2929C18.8946 17.4804 19 17.7348 19 18V22C19 22.2652 18.8946 22.5196 18.7071 22.7071C18.5196 22.8946 18.2652 23 18 23H2C1.73478 23 1.48043 22.8946 1.29289 22.7071C1.10536 22.5196 1 22.2652 1 22V18C1 17.7348 1.10536 17.4804 1.29289 17.2929C1.48043 17.1054 1.73478 17 2 17M7 5H8V3H7V5ZM7 13H8V11H7V13ZM7 21H8V19H7V21ZM3 3V5H5V3H3ZM3 11V13H5V11H3ZM3 19V21H5V19H3Z'
					stroke='#2E2E6B'
					strokeLinejoin='round'
				/>
			</svg>
		) : (
			<svg
				fill='none'
				height='22'
				viewBox='0 0 18 22'
				width='18'
				{...props?.innerSvgProps}
			>
				<path
					d='M1 0H17C17.2652 0 17.5196 0.105357 17.7071 0.292893C17.8946 0.48043 18 0.734784 18 1V5C18 5.26522 17.8946 5.51957 17.7071 5.70711C17.5196 5.89464 17.2652 6 17 6H1C0.734784 6 0.48043 5.89464 0.292893 5.70711C0.105357 5.51957 0 5.26522 0 5V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0ZM1 8H17C17.2652 8 17.5196 8.10536 17.7071 8.29289C17.8946 8.48043 18 8.73478 18 9V13C18 13.2652 17.8946 13.5196 17.7071 13.7071C17.5196 13.8946 17.2652 14 17 14H1C0.734784 14 0.48043 13.8946 0.292893 13.7071C0.105357 13.5196 0 13.2652 0 13V9C0 8.73478 0.105357 8.48043 0.292893 8.29289C0.48043 8.10536 0.734784 8 1 8ZM1 16H17C17.2652 16 17.5196 16.1054 17.7071 16.2929C17.8946 16.4804 18 16.7348 18 17V21C18 21.2652 17.8946 21.5196 17.7071 21.7071C17.5196 21.8946 17.2652 22 17 22H1C0.734784 22 0.48043 21.8946 0.292893 21.7071C0.105357 21.5196 0 21.2652 0 21V17C0 16.7348 0.105357 16.4804 0.292893 16.2929C0.48043 16.1054 0.734784 16 1 16ZM6 4H7V2H6V4ZM6 12H7V10H6V12ZM6 20H7V18H6V20ZM2 2V4H4V2H2ZM2 10V12H4V10H2ZM2 18V20H4V18H2Z'
					fill={props?.color ? props?.color : '#4C4CB2'}
				/>
			</svg>
		)
	);
};

export default MiddlewareSMOIcon;
